import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2017 } from "../../../../data/Convenios/dataConvenios";

const Convenios2017 = () => <ConveniosYearPage year={2017} data={convenios2017} />;

export default Convenios2017;